import * as Yup from 'yup';

export const ocaConfigurationSchemaStep3 = Yup.object().shape({
  additionalDays: Yup.string().test(
    'additionalDaysRange',
    'oca.config.costAndDays.errors.additionalDaysLimit',
    (value) => {
      if (value && (Number(value) < 0 || Number(value) > 365)) {
        return false;
      }
      return true;
    },
  ),
  allowFreeShipping: Yup.boolean(),
});
